import React from 'react';
import Hero from './Hero'; // Adjust the path if necessary

const Home = () => {
  return (
    <div>
      <Hero />
      {/* Other components can go here */}
    </div>
  );
};

export default Home;
